import * as z from 'zod';

import { StopSettings } from '../loan/StopSettings';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateStopSettingsEvent = BaseLoanEvent.extend({
  type: z.literal('updateStopSettings'),
  stopSettings: StopSettings,
});
export type UpdateStopSettingsEvent = z.infer<typeof UpdateStopSettingsEvent>;
